import {
  type SwappedWithdrawalLegs,
  isEvmChainId,
  isTokenEquivalent,
} from '@funkit/connect-core'

import type { WithdrawalFlowConfig } from '../flow/withdrawalFlowConfig'

/**
 * Decimals of the token Swapped accepts, when they cannot be read on-chain.
 * An EVM target is read from the chain (a stale config value would mis-scale
 * the transfer); a non-EVM target has no ERC-20 to read, so the config token
 * the route resolved to is trusted instead.
 */
export function resolveFiatTargetDecimals({
  config,
  route,
}: {
  config: Pick<WithdrawalFlowConfig, 'sourceToken' | 'swappedAcceptedToken'>
  route: Pick<SwappedWithdrawalLegs, 'targetChainId' | 'targetTokenAddress'>
}): number | undefined {
  if (isEvmChainId(route.targetChainId)) {
    return undefined
  }
  const target = [config.swappedAcceptedToken, config.sourceToken].find(
    (token) =>
      token?.decimals != null &&
      isTokenEquivalent({
        firstTokenChainId: token.chainId,
        firstTokenAddress: token.address,
        secondTokenChainId: route.targetChainId,
        secondTokenAddress: route.targetTokenAddress,
      }),
  )
  return target?.decimals
}
